import { createSlice } from '@reduxjs/toolkit';

const root = window?.post_template;
const clean = window.clean_settings;
const settings = window.general_settings;

const initialState = {
  settings: {
    logo: settings?.logo,
    logoWhite: settings?.logo_white,
    brandName: settings?.brand_name,
    formattedString: window.formattedString,
    phone: settings?.phone_number,
    email: settings?.support_email,
    link: window?.cta_link,
    root: window.template_root,
    bundleAmount: window.post_template.product_page_v6_hero.product_page_v6_hero_bundlePrice,
    disablePrices: window.post_template.product_page_v6_hero.product_page_v6_hero_showPrices,
    showPriceInCTA: window.post_template.product_page_v6_hero.product_page_v6_hero_showCTAprice,
    showQtyIncrementer: window.post_template.product_page_v6_hero.product_page_v6_hero_showIncrementer,
    isHeroVisible: true,
  },
  cleanSettings: {
    cleanMode: clean,
  },
  theme: {
    button: root?.product_page_v6_components?.product_page_v6_button_theme,
    heading: root?.product_page_v6_components?.product_page_v6_headings_theme,
    headingColor: root?.product_page_v6_components?.product_page_v6_title_text_color,
    subheadingColor: root?.product_page_v6_components?.product_page_v6_subtitle_text_color,
    customButton: {
      background: root?.product_page_v6_components?.product_page_v6_button_background,
      backgroudHover: root?.product_page_v6_components?.product_page_v6_button_background_hover,
      borderColor: root?.product_page_v6_components?.product_page_v6_button_background_border,
      textColor: root?.product_page_v6_components?.product_page_v6_button_text_color,
      borderColorSecondary: root?.product_page_v6_components?.product_page_v6_button_background_borderSecondary,
      hoverColorSecondary: root?.product_page_v6_components?.product_page_v6_button_hover_secondary,
      hoverTextColorSecondary: root?.product_page_v6_components?.product_page_v6_button_texthover_secondary,
    },
  },

  layout: {
    hero: {
      display: root.product_page_v6_hero?.product_page_v6_hero_show,
      layout: root.product_page_v6_hero?.product_page_v6_hero_layout || '',
    },
    promotional: {
      display: root.product_page_v6_promotional?.product_page_v6_promotional_display_section,
    },
    about: {
      display: root.product_page_v6_about?.product_page_v6_about_display_section,
    },
    usage: {
      display: root.product_page_v6_usage?.product_page_v6_usage_display_section,
    },
    featuredIn: {
      display: root.product_page_v6_slider?.product_page_v6_slider_display,
      layout: '',
    },
    videoTestimonials: {
      display: root?.product_page_v6_reviews?.product_page_v6_reviews_show,
      order: 5,
    },
    middleBar: {
      display: root?.product_page_v6_middleBar?.product_page_v6_middleBar_show,
    },
    videoTestimonialsImages: {
      display: root?.product_page_v6_reviews?.product_page_v6_reviewSlider_show,
    },
    baComparison: {
      display: root?.product_page_v6_baComparison?.product_page_v6_baComparison_show,
      order: root?.product_page_v6_baComparison?.product_page_v6_baComparison_order,
    },
    features: {
      display: root?.product_page_v6_featureslist?.product_page_v6_featuresList_show,
      layout: '',
    },
    setup: {
      display: root?.product_page_v6_setup?.product_page_v6_setup_show,
      layout: '',
    },
    competitorsComparison: {
      display: root?.product_page_v6_competitors?.product_page_v6_competitors_show,
      order: root?.product_page_v6_competitors?.product_page_v6_competitors_order,
    },

    testimonialsSlider: {
      display: root?.product_page_v6_testimonials?.product_page_v6_testimonials_show,
      layout: '',
    },

    ribbon: {
      display: root?.product_page_v6_benefitsRibbon?.product_page_v6_benefitsRibbon_showSection,
      layout: '',
    },
    faq: {
      display: root?.product_page_v6_faq?.product_page_v6_faq_display,
      layout: '',
    },
    awards: {
      display: root?.product_page_v6_awardCard?.product_page_v6_award_show,
      layout: '',
    },
    expert: {
      display: root?.product_page_v6_expert?.product_page_v6_expert_show,
      layout: '',
    },
    reviews: {
      display: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_show,
      layout: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_layout || '',
    },
    floater: {
      display: root?.product_page_v6_floater?.product_page_v6_floater_show,
      layout: '',
    },
  },
  header: {
    headerNavigationLinks: root?.product_page_v6_navigation?.product_page_v6_navigation_links,
    headerNavRightButtonText: root?.product_page_v6_navigation?.tr_product_page_v6_navigation_cta,
    styles: {
      background: root?.product_page_v6_navigation?.product_page_v6_navigation_background,
      textColor: root?.product_page_v6_navigation?.product_page_v6_navigation_linkColor,
      textHoverColor: root?.product_page_v6_navigation?.product_page_v6_navigation_linkHover,
      borderColor: root?.product_page_v6_navigation?.product_page_v6_navigation_borderColor,
    },
  },
  discountBar: {
    text: root.product_page_v6_discountBar?.tr_product_page_v6_discountBar_text,
    styles: {
      background: root.product_page_v6_discountBar?.product_page_v6_discountBar_background,
      textColor: root.product_page_v6_discountBar?.product_page_v6_discountBar_color,
    },
  },
  middleBar: {
    list: root?.product_page_v6_middleBar?.product_page_v6_middleBar_list,
    styles: {
      background: root?.product_page_v6_middleBar?.product_page_v6_middleBar_background,
      textColor: root?.product_page_v6_middleBar?.product_page_v6_middleBar_primaryColor,
    },
  },
  hero: {
    title: root?.product_page_v6_hero?.tr_product_page_v6_hero_heading,
    subtitle: root?.product_page_v6_hero?.tr_product_page_v6_hero_subheading,
    hero_image: root?.product_page_v6_hero?.product_page_v6_hero_staticImage,
    show_socials: root?.product_page_v6_hero?.product_page_v6_hero_showSocials,
    show_stockLeft: root?.product_page_v6_hero?.product_page_v6_hero_showStockLeft,
    divider_text: root?.product_page_v6_hero?.tr_product_page_v6_hero_dividerText,
    checkmarkIcon: root?.product_page_v6_hero?.product_page_v6_hero_checkmarkicon,
    shipping_details_repeater: root?.product_page_v6_hero?.product_page_v6_hero_shipping_details_repeater ?? [],
    bought_this: root?.product_page_v6_hero?.tr_product_page_v6_hero_bought_this,
    chart_label: root?.product_page_v6_hero?.tr_product_page_v6_hero_chartLabel,
    free_label: root?.product_page_v6_hero?.tr_product_page_v6_hero_freeLabel,
    left_label: root?.product_page_v6_hero?.tr_product_page_v6_hero_leftLabel,
    hero_banner_text: root?.product_page_v6_hero?.tr_product_page_v6_hero_banner_text,
    lowStockCountdownLabel: root?.product_page_v6_hero?.tr_product_page_v6_hero_tr_low_stock_label,
    availability_label: root?.product_page_v6_hero?.tr_product_page_v6_hero_limitedAvailability,
    trustpilot_excellent_label: root?.product_page_v6_hero?.tr_product_page_v6_hero_trustpilot_excellent_label,
    trustpilot_rating_image: root?.product_page_v6_hero?.product_page_v6_hero_trustpilot_rating_image,
    trustpilot_logo: root?.product_page_v6_hero?.product_page_v6_hero_trustpilot_logo,
    trustpilot_based_on_label: root?.product_page_v6_hero?.tr_product_page_v6_hero_trustpilot_based_on_label,
    each_label: root?.product_page_v6_hero?.tr_product_page_v6_hero_eachLabel,
    star_rating: {
      rating: root?.product_page_v6_hero?.product_page_v6_hero_score,
      rating_text: root?.product_page_v6_hero?.tr_product_page_v6_hero_score_rating_text,
      ratings_count: '158',
      ratings_count_text: root?.product_page_v6_hero?.tr_product_page_v6_hero_reviewsLabel,
      ratings_count_text_mobile: root?.product_page_v6_hero?.tr_product_page_v6_hero_reviewsLabel_mobile,
    },
    testimonials: root?.product_page_v6_hero?.product_page_v6_hero_testimonials,
    gallery: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery,
    useVideo: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery.use_video,
    galleryImage: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery.gallery_image,
    cloudflareVideoId: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery.cloudflare_video_id,
    cloudflareVideoThumb: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery.cloudflare_video_thumb,
    cloudflareVideoAutoplay: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery.cloudflare_video_autoplay,
    cloudflareVideo: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery.cloudflare_video_loop,

    faqList: root?.product_page_v6_hero?.product_page_v6_hero_faq,
    shopWithin: root?.product_page_v6_hero?.tr_product_page_v6_hero_orderWithin,
    shopWihinTwo: root?.product_page_v6_hero?.tr_product_page_v6_hero_orderWithin_two,
    checklist: root?.product_page_v6_hero?.product_page_v6_hero_checklist,

    rating_avatars: [
      '/temp_images/hero/rating_row/1.jpg',
      '/temp_images/hero/rating_row/2.jpg',
      '/temp_images/hero/rating_row/3.jpg',
      '/temp_images/hero/rating_row/4.jpg',
      '/temp_images/hero/rating_row/5.jpg',
    ],
    benefits: root?.product_page_v6_hero?.product_page_v6_hero_features,
    ctaButtonText: root?.product_page_v6_hero?.tr_product_page_v6_hero_ctaLabel,
    styles: {
      background: root?.product_page_v6_hero?.product_page_v6_hero_backgroundColor,
      borderColor: root?.product_page_v6_hero?.product_page_v6_hero_borderColor,
      textColorPrimary: root?.product_page_v6_hero?.product_page_v6_hero_textPrimary,
      textColorSubtitle: root?.product_page_v6_hero?.product_page_v6_hero_text_color_subtitle,
      textColorSecondary: root?.product_page_v6_hero?.product_page_v6_hero_textSecondary,
      heroBannerBackground: root?.product_page_v6_hero?.product_page_v6_hero_banner_background_color,
      accentColor: root?.product_page_v6_hero?.product_page_V6_hero_text_accent,
      bestSellerColor: root?.product_page_v6_hero?.product_page_v6_hero_background_best_seller,
      bestValueColor: root?.product_page_v6_hero?.product_page_v6_hero_background_best_value,
      featureTitleColor: root?.product_page_v6_hero?.product_page_v6_hero_featuresTitle_color,
      ratingsRowColor: root?.product_page_v6_hero?.product_page_v6_hero_ratingsRow_color,
      priceColor: root?.product_page_v6_hero?.product_page_v6_hero_priceColor,
      oldPriceColor: root?.product_page_v6_hero?.product_page_v6_hero_old_price_color,
      activeColor: root?.product_page_v6_hero?.product_page_v6_activecolor,
      radioColor: root?.product_page_v6_hero?.product_page_v6_radioColor,
      checkmarkColor: root?.product_page_v6_hero?.product_page_v6_checkmarkColor,
      testimonialsNameColor: root?.product_page_v6_hero?.product_page_v6_testimonials_username_color,
      shippingTextColor: root?.product_page_v6_hero?.product_page_v6_shipping_text_color,
      accordionTitleColor: root?.product_page_v6_hero?.product_page_v6_accordion_title_color,
      activeHeroThumbnailBorder: root?.product_page_v6_hero?.product_page_v6_gallery_image_border_color,
      dividerTextColor: root?.product_page_v6_hero?.product_page_v6_divider_text_color,
      shippingDetailsBackground: root?.product_page_v6_hero?.product_page_v6_hero_shipping_details_background,
    },
  },

  promotional: {
    title: root?.product_page_v6_promotional?.tr_product_page_v6_promotional_instant_relief_headline,
    repeater: root?.product_page_v6_promotional?.product_page_v6_promotional_icon_repeater,
    titleColor: root?.product_page_v6_promotional?.product_page_v6_promotional_title_color,
    scientifically_title: root?.product_page_v6_promotional?.tr_product_page_v6_promotional_scientifically_backed_label,
    scientifically_subtitle_color:
      root?.product_page_v6_promotional?.product_page_v6_promotional_scientifically_subtitle_color,
    scientifically_subtitle:
      root?.product_page_v6_promotional?.tr_product_page_v6_promotional_scientifically_backed_subtitle_label,
    scientifically_repeater: root?.product_page_v6_promotional?.product_page_v6_promotional_scientifically_repeater,
    composition_title: root?.product_page_v6_promotional?.tr_product_page_v6_promotional_composition_title,
    composition_subtitle: root?.product_page_v6_promotional?.tr_product_page_v6_promotional_composition_subtitle,
    composition_subtitle_color:
      root?.product_page_v6_promotional?.product_page_v6_promotional_composition_subtitle_color,
    composition_repeater: root?.product_page_v6_promotional?.product_page_v6_promotional_composition_repeater,
    ingredients_repeater: root?.product_page_v6_promotional?.product_page_v6_promotional_ingredients_repeater,
    ingredients_title: root?.product_page_v6_promotional?.tr_product_page_v6_promotional_ingredients_title,
    ingredients_subtitle: root?.product_page_v6_promotional?.tr_product_page_v6_promotional_ingredients_subtitle,
    ingredients_subtitle_color:
      root?.product_page_v6_promotional?.product_page_v6_promotional_ingredients_subtitle_color,
  },

  about: {
    title: root?.product_page_v6_about?.tr_product_page_v6_about_heading,
    description: root?.product_page_v6_about?.tr_product_page_v6_about_description,
    first_image: root?.product_page_v6_about?.product_page_v6_about_first_image,
    second_image: root?.product_page_v6_about?.product_page_v6_about_second_image,
    disclaimer: root?.product_page_v6_about?.tr_product_page_v6_about_disclaimer,
    second_title: root?.product_page_v6_about?.tr_product_page_v6_about_second_title,
    graphic_image: root?.product_page_v6_about?.product_page_v6_about_graphic_image,
    duration_repeater: root?.product_page_v6_about?.product_page_v6_about_duration_repeater,
    meter_image: root?.product_page_v6_about?.product_page_v6_about_meter_image,
    perks_repeater: root?.product_page_v6_about?.product_page_v6_about_perks_repeater,
    checkmark_icon: root?.product_page_v6_about?.product_page_v6_about_checkmark_icon,
    second_disclaimer: root?.product_page_v6_about?.tr_product_page_v6_about_second_disclaimer,
    rivals_headline: root?.product_page_v6_about?.tr_product_page_v6_about_rivals_headline,
    main_product_image: root?.product_page_v6_about?.product_page_v6_about_main_product_image,
    main_product_checkmark: root?.product_page_v6_about?.product_page_v6_about_main_product_checkmark,
    main_product_repeater: root?.product_page_v6_about?.product_page_v6_about_main_product_repeater,
    rival_product_image: root?.product_page_v6_about?.product_page_v6_about_rival_product_image,
    rival_checkmark_icon: root?.product_page_v6_about?.product_page_v6_about_rival_checkmark_icon,
    rival_product_repeater: root?.product_page_v6_about?.product_page_v6_about_rival_product_repeater,
  },

  features: {
    show: root?.product_page_v6_featureslist?.product_page_v6_featuresList_show,
    title: root?.product_page_v6_featureslist?.tr_product_page_v6_featureslist_heading,
    subtitle: root?.product_page_v6_featureslist?.tr_product_page_v6_featureslist_subheading,
    score: root?.product_page_v6_featureslist?.product_page_v6_featuresList_score,
    starsValue: root?.product_page_v6_featureslist?.product_page_v6_featuresList_stars,
    reviewsCount: root?.product_page_v6_featureslist?.product_page_v6_featuresList_reviews_count,
    reviewsLabel: root?.product_page_v6_featureslist?.tr_product_page_v6_featuresList_reviews_label,
    list: root?.product_page_v6_featureslist?.product_page_v6_featureslist_repeater,
    styles: {
      background: root?.product_page_v6_featureslist?.product_page_v6_featuresList_background,
      textColorPrimary: root?.product_page_v6_featureslist?.product_page_v6_featuresList_primaryColor,
      textColorSecondary: root?.product_page_v6_featureslist?.product_page_v6_featuresList_secondaryColor,
      checkboxColor: root?.product_page_v6_featureslist?.product_page_v6_featuresList_colorAccent,
    },
  },
  setup: {
    title: root?.product_page_v6_setup?.tr_product_page_v6_setup_title,
    subtitle: root?.product_page_v6_setup?.tr_product_page_v6_setup_subtitle,
    show: root?.product_page_v6_setup?.product_page_v6_setup_show,
    list: root?.product_page_v6_setup?.product_page_v6_setup_repeater,
    styles: {
      background: root?.product_page_v6_setup?.product_page_v6_setup_sectionBackground,
      textColorPrimary: root?.product_page_v6_setup?.product_page_v6_setup_textPrimary,
      textColorSecondary: root?.product_page_v6_setup?.product_page_v6_setup_textSecondary,
    },
  },
  FloatingCTA: {
    floaterImage: root?.product_page_v6_floater?.product_page_v6_floater_image,
    starsImage: root?.product_page_v6_floater?.product_page_v6_floater_stars,
    productScore: root?.product_page_v6_floater?.product_page_v6_floater_score,
    ctaLabel: root?.product_page_v6_floater?.tr_product_page_v6_floater_cta,
    timerLabel: root?.product_page_v6_floater?.tr_product_page_v6_floater_timer,
    floaterHeading: root?.product_page_v6_floater?.tr_product_page_v6_floater_heading,
    verbalScore: root?.product_page_v6_floater?.tr_product_page_v6_floater_scoreVerbal,
    styles: {
      background: root?.product_page_v6_floater?.product_page_v6_floater_gradient,
      textColorPrimary: root?.product_page_v6_floater?.product_page_v6_floater_textColorPrimaryy,
      textColorSecondary: root?.product_page_v6_floater?.product_page_v6_floater_textColorSecondary,
      buttonBackground: root?.product_page_v6_floater.product_page_v6_floater_ctaBackground,
      ctaTextColor: root?.product_page_v6_floater.product_page_v6_floater_textColor,
      buttonHoverBackground: root?.product_page_v6_floater?.product_page_v6_floater_hoverColor,
    },
  },
  usage: {
    main_image: root?.product_page_v6_usage?.product_page_v6_usage_main_image,
    headline_text: root?.product_page_v6_usage?.tr_product_page_v6_usage_headline_text,
    description_text: root?.product_page_v6_usage?.tr_product_page_v6_usage_description_text,
    enable_cloudflare_video: root?.product_page_v6_usage?.use_video_instead_of_image,
    cloudflare_video_id: root?.product_page_v6_usage?.cloudflare_video_id,
    cloudflare_autoplay: root?.product_page_v6_usage?.cloudflare_video_autoplay,
    cloudflare_loop: root?.product_page_v6_usage?.cloudflare_video_loop,
    usage_repeater: root?.product_page_v6_usage?.product_page_v6_usage_repeater,
    social_slider_repeater: root?.product_page_v6_usage?.product_page_v6_social_slider_repeater,
    social_comments_repeater: root?.product_page_v6_usage?.product_page_v6_social_comments_repeater,
    expert_image: root?.product_page_v6_usage?.product_page_v6_usage_expert_image,
    expert_title: root?.product_page_v6_usage?.tr_product_page_v6_usage_expert_title,
    expert_description: root?.product_page_v6_usage?.tr_product_page_v6_usage_expert_description,
    expert_divider_color: root?.product_page_v6_usage?.product_page_v6_usage_expert_divider_color,
    expert_position: root?.product_page_v6_usage?.tr_product_page_v6_usage_expert_position,
    expert_signature: root?.product_page_v6_usage?.tr_product_page_v6_usage_expert_signature,
    expert_signature_image: root?.product_page_v6_usage?.product_page_v6_usage_expert_signature_image,

    styles: {
      icon_color: root?.product_page_v6_usage?.product_page_v6_usage_icon_color,
      number_color: root?.product_page_v6_usage?.product_page_v6_usage_number_color,
      background_color: root?.product_page_v6_usage?.product_page_v6_usage_section_background_color,
      expert_background_color: root?.product_page_v6_usage?.product_page_v6_usage_expert_background_color,
      expert_divider_color: root?.product_page_v6_usage?.product_page_v6_usage_expert_divider_color,
      social_slider_background_color: root?.product_page_v6_usage?.product_page_v6_social_slider_background_color,
    },
  },
  competitorsComparison: {
    heading: root?.product_page_v6_competitors?.tr_product_page_v6_competitors_heading,
    tableHeading: root?.product_page_v6_competitors?.tr_product_page_v6_competitors_tableHeading,
    ctaLabel: root?.product_page_v6_competitors?.tr_product_page_v6_competitors_cta,
    moneyBackLabel: root?.product_page_v6_competitors?.tr_product_page_v6_competitors_moneyBack,
    otherProduct: root?.product_page_v6_competitors?.tr_product_page_v6_competitors_otherLabel,
    productImage: root?.product_page_v6_competitors?.product_page_v6_competitors_image,
    ourProductLogo: root?.product_page_v6_competitors?.product_page_v6_competitors_our_product_logo,
    competitorsImage: root?.product_page_v6_competitors?.product_page_v6_competitors_otherImage,
    repeater: root?.product_page_v6_competitors?.product_page_v6_competitors_table,
    styles: {
      background: root?.product_page_v6_competitors?.product_page_v6_competitors_background,
      evenTable: root?.product_page_v6_competitors?.product_page_v6_competitors_even,
      oddTable: root?.product_page_v6_competitors?.product_page_v6_competitors_odd,
      textColorPrimary: root?.product_page_v6_competitors?.product_page_v6_competitors_primaryColor,
      tetColorSecondary: root?.product_page_v6_competitors?.product_page_v6_competitors_secondaryColor,
      oddTableOur: root?.product_page_v6_competitors?.product_page_v6_competitors_oddOur,
      evenTableOur: root?.product_page_v6_competitors?.product_page_v6_competitors_evenOur,
    },
  },
  testimonialsSwiper: {
    title: root?.product_page_v6_testimonials?.tr_product_page_v6_testimonials_heading,
    subtitle: root?.product_page_v6_testimonials?.tr_product_page_v6_testimonials_subheading,
    ratedLabel: root?.product_page_v6_testimonials?.tr_product_page_v6_ratedLabel,
    list: root?.product_page_v6_testimonials?.product_page_v6_testimonials_repeater,
    styles: {
      borderColor: root?.product_page_v6_testimonials?.product_page_v6_testimonials_border_color,
      cardBackground: root?.product_page_v6_testimonials?.product_page_v6_testimonials_cardBackgrounddd,
      background: root?.product_page_v6_testimonials?.product_page_v6_testimonials_background,
      textColorPrimary: root?.product_page_v6_testimonials?.product_page_v6_testimonials_primary_color,
      textColorSecondary: root?.product_page_v6_testimonials?.product_page_v6_testimonials_secondary_color,
      textColorAccent: root?.product_page_v6_testimonials?.product_page_v6_testimonials_accent_color,
    },
  },

  baComparison: {
    title: root?.product_page_v6_baComparison?.tr_product_page_v6_baComparison_heading,
    list: root?.product_page_v6_baComparison?.product_page_v6_baComparison_repeater,
    styles: {
      background: root?.product_page_v6_baComparison?.product_page_v6_baComparison_background,
      textColorPrimary: root?.product_page_v6_baComparison?.product_page_v6_baComparison_primaryColor,
      textColorSecondary: root?.product_page_v6_baComparison?.product_page_v6_baComparison_secondaryColor,
    },
  },
  videoTestimonials: {
    title: root?.product_page_v6_reviews?.tr_product_page_v6_reviews_heading,
    rating: 4.7,
    ratingText: root?.product_page_v6_reviews?.tr_product_page_v6_reviews_trusted,
    verifiedText: 'Verified',
    verifyIcon: '/images/homepage/testimonialsSection/testimonialCard/verify.svg',
    testimonials: root?.product_page_v6_reviews?.product_page_v6_reviews_video_repeater,
    styles: {
      background: root?.product_page_v6_reviews?.product_page_v6_reviews_background,
    },
  },
  videoTestimonialsImages: {
    repeater: root?.product_page_v6_reviews?.product_page_v6_reviews_images,
  },
  productsSection: {
    title: root?.product_page_v6_products?.tr_product_page_v6_products_heading,
    reviewsText: 'Verified Reviews',
    products: root?.product_page_v6_products?.product_page_v6_products_sectionRepeater,
    styles: {
      background: root?.product_page_v6_products?.product_page_v6_products_background,
      backgroundAccent: root?.product_page_v6_products?.product_page_v6_products_backgroundAccent,
      backgroundBadge: root?.product_page_v6_products?.product_page_v6_products_backgroundDiscount,
      textColorPrimary: root?.product_page_v6_products?.product_page_v6_products_textPrimary,
      textColorSpan: root?.product_page_v6_products?.product_page_v6_products_textColorSpan,
      textColorSecondary: root?.product_page_v6_products?.product_page_v6_products_textSecondary,
      accentColor: root?.product_page_v6_products?.product_page_v6_products_textAccent,
      badgeColor: root?.product_page_v6_products?.product_page_v6_products_background,
      borderColor: root?.product_page_v6_products?.product_page_v6_products_cardDefaultBorder,
      borderColorHover: root?.product_page_v6_products?.product_page_v6_products_card_borderColorOnHover,
    },
  },

  slidingTextBar: {
    repeater: root?.product_page_v6_benefitsRibbon?.product_page_v6_benefitsRibbon_repeater,
    styles: {
      background: root?.product_page_v6_benefitsRibbon?.product_page_v6_benefitsRibbon_background,
      textColor: root?.product_page_v6_benefitsRibbon?.product_page_v6_benefitsRibbon_textColor,
    },
  },
  FAQ: {
    sectionTitle: root?.product_page_v6_faq?.tr_product_page_v6_faq_title,
    items: root?.product_page_v6_faq?.product_page_v6_faq_list_repeater,
    moneyback_title: root?.product_page_v6_faq?.tr_product_page_v6_faq_moneyback_title,
    moneyback_subtitle: root?.product_page_v6_faq?.tr_product_page_v6_faq_moneyback_subtitle,
    moneyback_description: root?.product_page_v6_faq?.tr_product_page_v6_faq_moneyback_description,
    moneyback_image: root?.product_page_v6_faq?.product_page_v6_faq_moneyback_image,
    moneyback_icon: root?.product_page_v6_faq?.product_page_v6_faq_moneyback_icon,
    styles: {
      background: root?.product_page_v6_faq?.product_page_v6_faq_background,
      titleColor: root?.product_page_v6_faq?.product_page_v6_faq_titleColor,
      money_back_background: root?.product_page_v6_faq?.product_page_v6_faq_moneyback_background_gradient,
    },
  },

  customerReviewsBlock: {
    title: root?.product_page_v6_reviewsList?.tr_product_page_v6_reviewsList_title,
    subtitle: root?.product_page_v6_reviewsList?.tr_product_page_v6_reviewsList_subtitle,
    reviews: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_repeater,
    showLessLabel: root?.product_page_v6_reviewsList?.tr_product_page_v6_reviewslist_loadLess,
    showMoreLabel: root?.product_page_v6_reviewsList?.tr_product_page_v6_reviewslist_readmore,
    verifiedLabel: root?.product_page_v6_reviewsList?.tr_product_page_v6_reviewsList_verified,
    helpfulLabel: root?.product_page_v6_reviewsList?.tr_product_page_v6_reviewsList_helpfulLabel,
    loadSlides: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_index,
    styles: {
      background: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_background,
      buttonColor: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_buttonColor,
      bubbleBackground: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_initialBubbleColor,
    },
  },
  statistics: {
    reviewsLabel: root?.product_page_v6_reviews_score.tr_product_page_v6_reviews_score_reviewsLabel,
    writeReviewLabel: root?.product_page_v6_reviews_score.tr_product_page_v6_reviews_score_writeReviewLabel,
    numberOfReviews: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_number,
    reviewsAverage: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_int,
    percentOfReviewers: root?.product_page_v6_reviews_score.tr_product_page_v6_reviews_score_percent,
    repeater: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_qualities,
    styles: {
      barActive: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_colorActive,
      barPassive: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_colorPassive,
      textColorPrimary: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_colorPassive,
      textColorSecondary: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_textSecondary,
      totalScoreColor: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_total_score_color,
      numbersColor: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_numbers_color,
      specificationsColor: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_specifications_color,
    },
  },

  bottomBanner: {
    show: root?.product_page_v6_bottom_banner?.product_page_v6_bottom_banner_show,
    title: root?.product_page_v6_bottom_banner?.tr_product_page_v6_bottom_banner_title,
    bannerBackground: root?.product_page_v6_bottom_banner?.product_page_v6_bottom_banner_image,
    checklist: root?.product_page_v6_bottom_banner?.product_page_v6_bottom_banner_repeater,
    styles: {
      backgroundGradient: root?.product_page_v6_bottom_banner?.product_page_v6_bottom_banner_background_gradient,
      checkmarkColor: root?.product_page_v6_bottom_banner?.product_page_v6_bottom_banner_checkmarkColor,
      textColorSecondary: root?.product_page_v6_bottom_banner?.product_page_v6_bottom_banner_textColorSecondary,
    },
  },
  footer: {
    newsletter: {
      title: root?.product_page_v6_footer?.tr_newsLetter_title,
      formInputPlaceholder: root?.product_page_v6_footer?.tr_input_placeholder,
      formSubmitText: root?.product_page_v6_footer?.tr_submit_label,
      textAfterSubscribeForm: root?.product_page_v6_footer?.tr_submit_afterLabel,
      rating: 4.7,
    },
    benefits: root?.product_page_v6_footer?.product_page_v6_footer_benefits,
    text: root?.product_page_v6_footer?.tr_footer_product_description,
    copyText: root?.product_page_v6_footer?.tr_footer_copyrights_text,
    customerCareLabel: root?.product_page_v6_footer?.tr_footer_customer_care_label,
    emailSupportLabel: root?.product_page_v6_footer?.tr_footer_email_support_label,
    helpCenterLabel: root?.product_page_v6_footer?.tr_footer_help_center_label,
    liveChatLabel: root?.product_page_v6_footer?.tr_footer_chat_support_label,
    links: root?.product_page_v6_footer?.footer_link_columns,
    styles: {
      background: root?.product_page_v6_footer?.footer_section_background_color,
      primaryColor: root?.product_page_v6_footer?.footer_text_color,
      linkHoverColor: root?.product_page_v6_footer?.footer_link_text_color_hover,
      borderColor: root?.product_page_v6_footer?.footer_borders_color,
      dividerColor: root?.product_page_v6_footer?.footer_divider_color,
    },
    footerLogo: root?.product_page_v6_footer?.footer_logo,
  },
};

const wpdataSlice = createSlice({
  name: 'wpdata',
  initialState,
  reducers: {},
});

export default wpdataSlice.reducer;
